<!-- eslint-disable -->
<template>
    <div class="picker-container form-order-picker-container">
        <nodata
            v-if="!list || !list.length"
            :loading="loading"
            text="没有相关订单"
        ></nodata>
        <div class="picker-content order-picker" v-else>
            <div class="order-list">
                <div
                    class="order-card"
                    v-for="(order, orderIndex) in list"
                    :key="orderIndex"
                >
                    <div class="order-title">
                        <svg class="shop-pic" width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <title>icon/店铺</title>
                            <g id="icon/店铺" stroke="none" stroke-width="1" fill-rule="evenodd">
                                <path d="M4.22758266,8.88752346 L4.22758266,14.7705214 C4.22758266,14.781948 4.23452997,14.7917519 4.24443107,14.7959397 L4.25516887,14.7981076 L13.7648262,14.7981076 C13.7762528,14.7981076 13.7860567,14.7911603 13.7902445,14.7812592 L13.7924124,14.7705214 L13.7924124,8.88752346 L14.9890638,8.88752346 L14.9890638,14.3865196 C14.9890638,15.2649813 14.2931147,15.9808954 13.4224953,16.0129832 L13.3614776,16.0141058 L4.64190379,16.0141058 C3.76344209,16.0141058 3.047528,15.3181567 3.0154402,14.4475373 L3.01431758,8.88752346 L4.22758266,8.88752346 Z" id="形状结合" fill-rule="nonzero"></path>
                                <path d="M13.7598359,2.5 C14.7207533,2.5 15.5458541,3.18337506 15.7248362,4.12747659 L16.5,8.21633942 C16.3965356,9.04902781 15.5233119,9.74137931 14.4457048,9.74137931 C13.5901669,9.74137931 12.8476754,9.30030128 12.5390738,8.67154409 C12.3136235,8.21220261 11.7412985,8.1597195 11.4436403,8.53847523 L11.384287,8.62624666 C11.0097515,9.27258636 10.0772378,9.74137931 9.00009282,9.74137931 C7.97190258,9.74137931 7.07539578,9.31422782 6.66981178,8.71299528 L6.61524961,8.62594802 C6.34156957,8.15410815 5.70179369,8.17953081 5.4604581,8.67183576 C5.15236676,9.30031701 4.4100198,9.74137931 3.55448087,9.74137931 L3.43565843,9.73855817 C2.45329934,9.69177292 1.50044042,9.16387942 1.5,8.30825479 L2.2851186,4.13060096 C2.46282079,3.18503905 3.28859361,2.5 4.25070868,2.5 L13.7598359,2.5 Z M13.7598359,3.7 L4.25070868,3.7 C3.90434725,3.7 3.60216072,3.92195265 3.49336907,4.24206903 L3.46447265,4.35224038 L2.717,8.325 L2.73280237,8.33685304 C2.80868362,8.3883786 3.01392697,8.49003271 3.32460715,8.52723332 L3.46414137,8.53889625 L3.55448087,8.54137931 C3.95361868,8.54137931 4.27894667,8.35581201 4.38296156,8.14363011 C5.02141157,6.84124406 6.76592638,6.72631487 7.5490651,7.85777575 L7.66462041,8.04190975 C7.84000349,8.30189539 8.37091723,8.54137931 9.00009282,8.54137931 C9.59992418,8.54137931 10.1054389,8.32383716 10.3346955,8.03459478 L10.5001362,7.79699023 C11.3504931,6.71495185 13.0058977,6.89912933 13.6163163,8.1428205 C13.7207748,8.35564838 14.0464215,8.54137931 14.4457048,8.54137931 C14.7996047,8.54137931 15.081835,8.40071537 15.2193526,8.24433784 L15.27,8.173 L14.545836,4.35099063 C14.4814024,4.01111408 14.2076264,3.75571291 13.873312,3.70803144 L13.7598359,3.7 Z" id="路径" fill-rule="nonzero"></path>
                            </g>
                        </svg>
                        <div class="shop-name">
                            {{ order.sellerNick }}
                        </div>
                        <div class="order-status">
                            {{ order.orderStatusView }}
                        </div>
                    </div>
                    <div class="item-list">
                        <div
                            v-for="(item, index) in order.itemList"
                            class="item"
                            :key="index"
                            @click="onClick(index, order)"
                        >
                            <div class="item-cover">
                                <img :src="item.picUrl" />
                            </div>
                            <div class="item-detail">
                                <div class="item-title">
                                    {{ item.name }}
                                </div>
                                <div class="item-content" v-if="item.specification">
                                    {{ item.specification }}
                                </div>
                                <div class="item-content">
                                    下单时间: {{ order.orderCreateTime | formatDate }}
                                </div>
                            </div>
                            <div class="item-number">
                                <div class="amount">
                                    <span class="unit">¥</span>
                                    <order-money-font :money="order.orderFee | formatMoneyFen"></order-money-font>
                                </div>
                                <div class="count">
                                    x{{ item.num }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <!-- <div v-if="hasMore" v-io @exposed="loadMore">正在加载</div> -->
                <div
                    v-if="hasMore"
                    class="hasmore-loading"
                    v-io
                    @exposed="loadMore"
                ></div>
                <div v-else>
                    没有更多订单了
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import IntersectionObserve from '../../utils/directives/intersection-observe';
import { formatMoneyFen, formatDate } from '../../utils/filters';
import Nodata from './nodata.vue';
import OrderMoneyFont from './order-money-font.vue';
import { CONFIG, getFansSpecification, getOrderCategory, fetchOrderList, getDealwithOrder } from './order-util';
export default {
    name: 'order-list',
    components: {
        Nodata,
        OrderMoneyFont,
    },
    filters: {
        formatMoneyFen,
        formatDate,
    },
    directives: {
        io: IntersectionObserve,
    },
    props: {
        api: {
            type: String,
            default: '/rest/csc/center/order/all/list',
        },
        isPageParams: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            list: [],
            scrollId: 0,
            page: 0,
            pageSize: 10,
            hasMore: false,
            loading: false,
            loadMoreInterval: 0,
            autocompleted: false,
        };
    },
    async created() {
        await this.getList();
    },
    beforeDestroy() {
        window.clearInterval(this.loadMoreInterval);
    },
    methods: {
        async getList() {
            if (this.loading) {
                return;
            }
            this.loading = true;
            try {
                const params = {
                    pageSize: this.pageSize,
                };

                this.isPageParams ? params.page = this.page : params.scrollId = this.scrollId;
                const { data } = await fetchOrderList(params, this.api);
                const orderList = data.orderList.map(order => {
                    const category = getOrderCategory(order.orderType);
                    const config = CONFIG[category];
                    if (!config) {
                        return order;
                    }
                    return {
                        ...order,
                        itemList: order.itemList && order.itemList.map(item => {
                            const filledItem = {
                                ...item,
                                picUrl: config.picUrl,
                            };
                            if (category === 'fans') {
                                filledItem.specification = getFansSpecification(order);
                            }
                            return filledItem;
                        }),
                        sellerNick: '快手',
                    };
                });
                this.list = this.list.concat(orderList);
                console.log(this.list, orderList);
                this.hasMore = data.hasMore;
                this.scrollId = data.scrollId;
                if (this.isPageParams) {this.page++;}
            } catch (err) {
                console.log('err', err);
                //
            } finally {
                this.loading = false;
                window.clearInterval(this.loadMoreInterval);
            }
        },
        loadMore() {
            // TODO: 如果带入的oid不在当前列表中，需要loadmore
            // console.log('[zy] loadMore', );
            this.getList();
            this.loadMoreInterval = window.setInterval(this.getList, 500);
        },
        onClick(itemIndex, order) {
            this.$emit('picked', getDealwithOrder(order, itemIndex));
        },
    },
};
</script>
<style lang="less" scoped>
.picker-content.order-picker {
    padding: 0;
    .order-card {
        background: #fff;
        margin: 0 0.11rem 0.12rem 0.11rem;
        border-radius: 0.08rem;
        padding: 0.12rem;
        &:first-child {
            .order-title {
                padding-top: 0;
            }
        }
        .order-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 0.16rem;
            .shop-pic {
                width: 0.18rem;
                height: 0.18rem;
                margin-right: 0.04rem;
            }
            .shop-name {
                flex: 1;
                font-size: 0.15rem;
                line-height: 0.2rem;
            }
            .order-status {
                font-size: 0.14rem;
                color: #fe3666;
                line-height: 0.18rem;
            }
        }
        .item {
            height: 0.9rem;
            display: flex;
            .item-cover {
                width: 0.9rem;
                height: 0.9rem;
                border-radius: 0.08rem;
                overflow: hidden;
                flex-shrink: 0;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }
        .item-detail {
            width: 2.06rem;
            margin: 0 0.04rem 0 0.12rem;
            & > div {
                max-width: 100%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .item-title {
                font-size: 0.15rem;
                line-height: 0.2rem;
            }
            .item-content {
                font-size: 0.14rem;
                line-height: 0.18rem;
                margin-top: 0.07rem;
                color: #9c9c9c;
            }
        }
        .item-number {
            flex: 1;
        }
        .amount {
            line-height: 0.2rem;
            text-align: right;
            white-space: nowrap;
            .unit {
                font-size: 0.12rem;
            }
        }
        .count {
            font-size: 0.13rem;
            line-height: 0.14rem;
            color: #9c9c9c;
            text-align: right;
            margin-right: 0.01rem;
        }
    }
    .bottom {
        padding: 0.14rem 0 0.24rem;
        font-size: 0.14rem;
        line-height: 0.18rem;
        color: #9c9c9c;
        text-align: center;
    }
}
</style>
